
import React from "react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface CancelButtonProps {
  onCancelLastEntry: () => void;
  disabled: boolean;
}

const CancelButton: React.FC<CancelButtonProps> = ({ onCancelLastEntry, disabled }) => {
  const { t } = useTranslation("training");
  
  return (
    <Button 
      onClick={onCancelLastEntry} 
      className={`h-12 font-medium ${
        disabled 
          ? "bg-red-100 text-red-400" 
          : "bg-red-200 hover:bg-red-300 text-red-700"
      } border-0 w-full mt-2`}
      disabled={disabled}
    >
      {t("interface.cancelLastEntry")}
    </Button>
  );
};

export default CancelButton;
